import type { ConnectedPosition } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import type { OverlayPosition } from '@core/prosemirror-legacy';
import type { WysiwygLink } from '@core/wysiwyg-legacy';

export interface SchedulerLinksDropdownListOpenOptions {
  preferredPositions?: ConnectedPosition[];
}

export interface SchedulerLinksDropdownListController {
  open: (
    position: OverlayPosition | DOMRect,
    options?: SchedulerLinksDropdownListOpenOptions,
  ) => { element: HTMLElement; backdropClick$: Observable<MouseEvent> };
  setSelectCallback: (selectCb: (val: WysiwygLink) => void) => void;
  close: () => void;
  updatePosition: (position: OverlayPosition) => void;
  isOpen: () => boolean;
}

export interface SchedulerAvailabilityInterface {
  isAvailable: boolean;
  hasAbility: boolean;
  openUpsellDialog: () => void;
}

export const SchedulerAvailabilityToken = new InjectionToken<
  new () => SchedulerAvailabilityInterface
>('SchedulerAvailabilityToken');
